import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { Box, Button, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { Icon } from '@/components/shared/icon';
import { useProfileShow } from '@/data/account/profile';
import { useCatalogOffer } from '@/data/catalog/offer';
import { HelpFooter } from '@/packages/courses/pages/registration/components/help-footer';
import { NextStepsDialog } from '@/packages/courses/pages/registration/components/next-steps-dialog';

interface SubscriptionInProgressProps {
  offerId?: number;
  institutionName?: string;
}

export const SubscriptionInProgress = ({
  offerId,
  institutionName,
}: SubscriptionInProgressProps) => {
  const [showNextSteps, setShowNextSteps] = useState(false);
  const { offer } = useCatalogOffer(offerId ?? 0);
  const { profile } = useProfileShow();

  const subscriptionConfig = offer?.institution_subscription_config;

  return (
    <Stack alignItems="flex-start">
      <Icon name="tea-cup" />

      <Typography variant="h2" mt={2}>
        Sua matrícula está em andamento.
      </Typography>

      <Box mt={1} sx={{ '& .MuiTypography-root': { lineHeight: 1.7 } }}>
        <Typography>
          As próximas informações serão enviadas para o e-mail cadastrado.
        </Typography>
        <Typography>
          Não deixe de verificar também as pastas de spam e lixo eletrônico.
        </Typography>
      </Box>

      <Button
        variant="outlined"
        endIcon={<ArrowRightAltIcon />}
        onClick={() => setShowNextSteps(true)}
        sx={{ mt: 1 }}
      >
        Confira os próximos passos
      </Button>

      <Box mt={3}>
        <HelpFooter />
      </Box>

      {showNextSteps && (
        <NextStepsDialog
          onClose={() => setShowNextSteps(false)}
          config={subscriptionConfig}
          institutionName={institutionName}
          email={profile?.email}
          phone={profile?.cellphone_number}
        />
      )}
    </Stack>
  );
};
